module.exports = __webpack_public_path__ + "img/wait.e7e41218.gif";